import { postFor as base } from '../common/PostBuilder';
import OopsOverlayView from './OopsOverlay/OopsOverlay';

const postFor = function (options) {
  base(options, OopsOverlayView);
};

/* eslint-disable */
export {
  postFor,
};
/* eslint-enable */
